export default __webpack_public_path__ + "static/media/glrc-course.chocolate-techniques.0af0b242.png";